module.exports = __webpack_public_path__ + "static/media/clouds-1.0ad6bfd1.svg";